/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-negated-condition */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
// import StatusFormatter from 'components/StatusFormatter';
import { FSBTable } from 'components/common/FSBTable';
import FSBModal from 'components/common/FSBModal';
import {
  EXPORTS_PRODUCT,
  PRODUCT_LIST,
  PRODUCT_LIST_SUBSCRIPTION,
} from 'pages/Products/ProductsGraphQL';
import { productColumns } from 'pages/Products/constant';
import Loader from 'components/common/Loader';
import {
  ADD_EDIT_CONSTANT,
  USER_ID,
  defaultDeleteFilter,
  showSequenceNumber,
} from 'utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import DownloadCSV from 'components/DownloadCSV';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import { setUserDetails } from 'actions/userDetailsAction';
import ActionsFormatter from 'components/ActionsFormatter';
import { Button } from 'reactstrap';
import { IoMdAdd } from 'react-icons/io';
import ProductMobileList, {
  buildProductAuditSection,
  createdAtDetail,
} from 'pages/Products/components/ProductMobileList';
import ProductDetails from './ProductDetails';

const ProductTable = ({
  searchString,
  toggleDeleteRecord,
  handleClickEdit,
  toggleAddRecord,
}) => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'name',
        // joinAttributeName: '',
        value: searchString,
        type: 'STRING',
        op: 'LIKE',
      },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
    pagination: true,
  });
  const [showProductDetails, setShowProductDetails] = useState({
    status: false,
    row: null,
  });

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    PRODUCT_LIST,
    {
      variables: {
        ...filters,
        filter: [...filters.filter],
      },
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: PRODUCT_LIST_SUBSCRIPTION,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.productList.productList.findIndex(
          (val) => val.id === subscriptionData.data?.productList?.product?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.productList?.product?.id) return prev;
        if (subscriptionData.data.productList.action === 'CREATED') {
          const newProductList = subscriptionData.data.productList.product;
          const updatedProductList = [
            newProductList,
            ...newData.productList.productList,
          ];

          const newTotalCount = prev.productList.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.productList = {
            ...newData.productList,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            productList: updatedProductList,
          };
        }
        if (subscriptionData.data.productList.action === 'UPDATED') {
          newData.productList.productList[indexFound] =
            subscriptionData.data.productList.product;
        }

        if (subscriptionData.data.productList.action === 'DELETED') {
          const { id } = subscriptionData.data.productList.product; // ID of the category to remove
          const prevProductList = prev.productList.productList;

          const updatedProductList = prevProductList.filter(
            (val) => val.id !== id,
          );

          const newTotalCount = prev.productList.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedProductListData = {
            ...newData.productList,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            productList: updatedProductList,
          };

          newData.productList = updatedProductListData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  // const [updateCategoryStatus] = useMutation(UPDATE_CATEGORY_STATUS, {
  //   // eslint-disable-next-line no-shadow
  //   onCompleted: () => {
  //     toast.success(STATUS_UPDATED_SUCCESSFULLY);
  //   },
  //   onError: ({ graphQLErrors }) => {
  //     graphQLErrors.map(({ message }) => {
  //       return message;
  //     });
  //     toast.error(SOMETHING_WENT_WRONG);
  //   },
  // });

  // const handleStatusChange = async (e, cell) => {
  //   try {
  //     await updateCategoryStatus({
  //       variables: { id: cell?.row?.original?.id, status: e.target.value },
  //     });
  //     refetch();
  //   } catch (err) {
  //     toast.error(err);
  //   }
  // };

  // const statusFormatter = (cell) => {
  //   return (
  //     <StatusFormatter
  //       options={PRODUCT_STATUS}
  //       defaultValue={cell?.row?.original?.status}
  //       handleChange={(e) => handleStatusChange(e, cell)}
  //     />
  //   );
  // };

  const actionsFormatter = (cell) => {
    return (
      <ActionsFormatter
        isView={false}
        isDelete={false}
        handleDelete={() => toggleDeleteRecord(cell?.row?.original?.id)}
        // handleView={() => toggleShowDetails(cell?.row?.original)}
        handleEdit={() =>
          handleClickEdit(cell?.row?.original, ADD_EDIT_CONSTANT.EDIT)
        }
      />
    );
  };

  const toggleShowDetails = (row) => {
    setShowProductDetails((prev) => ({
      status: !prev.status,
      row: row ?? prev.row,
    }));
  };
  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() => toggleShowDetails(cell?.row?.original)}
        aria-hidden
      >
        {cell?.row?.original?.name}
      </div>
    );
  };

  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const linkFormatterForUserId = (cell, userId) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() =>
          handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
        }
        aria-hidden
      >
        {cell?.row?.original?.[userId]}
      </div>
    );
  };

  const findIndexOfItem = (item) => {
    return productColumns.findIndex((itm) => itm.accessorKey === item);
  };
  // productColumns[findIndexOfItem('status')].cell = statusFormatter;
  productColumns[findIndexOfItem('actions')].cell = actionsFormatter;
  productColumns[findIndexOfItem('name')].cell = linkFormatter;
  productColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  productColumns[findIndexOfItem(USER_ID.CREATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.CREATED_ID);
  productColumns[findIndexOfItem(USER_ID.UPDATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.UPDATED_ID);

  // const onDeleteConfirmation = async () => {
  //   const { id, email } = selectedUserRow;
  //   const rowId = selectedRows.map(({ original }) => original.id);
  //   const rowEmail = selectedRows.map(({ original }) => original.email);
  //   // await deleteUser({
  //   //   variables: {
  //   //     id: id ? [id] : rowId,
  //   //     email: email ? [email] : rowEmail,
  //   //   },
  //   // });

  //   setSelectedRows([]);
  //   setSelectedUserRow([]);
  //   setDeleteRecord(false);
  // };

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.productList?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  if (loading) return <Loader />;
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.productList?.productList)
    return <NoDataFound message="Product not available" />;

  return (
    <>
      <FSBModal
        size="xl"
        title="Product Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showProductDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer right-drawer-details"
      >
        <ProductDetails productDetails={showProductDetails.row} />
      </FSBModal>
      {/* <FSBModal
        size="xl"
        title="Categories Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        open={showDetails.status}
        toggleAlert={toggleShowDetails}
        onClose={toggleShowDetails}
        modalClass="right-drawer details-drawer"
      >
        <CategoriesDetails currentRowData={showDetails.row} />
      </FSBModal> */}

      {/* <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      /> */}
      <DownloadCSV
        lazyQuery={EXPORTS_PRODUCT}
        filters={filters}
        apiKey="exportProducts"
        fileName="Product"
        positionTop="-52px"
        positionRight="37px"
        classWrapper="product-csv-btn products-download-btn"
      />

      <Button
        color="primary"
        className="position-absolute rounded-btn p-0 rounded-circle d-flex align-items-center justify-content-center products-add-btn"
        size="sm"
        onClick={toggleAddRecord}
        style={{ top: '15px', right: '20px' }}
      >
        <IoMdAdd color="#fff" size={20} />
      </Button>

      <ProductMobileList
        items={(data && data?.productList?.productList) || []}
        totalPages={(data && data?.productList?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        getTitle={(item) => item?.name || 'N/A'}
        getMeta={(item) =>
          `ID ${item?.id || 'N/A'} | ${item?.category?.name || 'N/A'}`
        }
        getSections={(item) => ({
          Overview: [
            { label: 'Category', value: item?.category?.name || 'N/A' },
            createdAtDetail(item),
            { label: 'Status', value: item?.status || 'N/A', tone: 'status' },
          ],
          Audit: buildProductAuditSection(item),
        })}
        onTitleClick={toggleShowDetails}
        renderActions={(item) => actionsFormatter({ row: { original: item } })}
        handleUserId={handleUserId}
      />
      <div className="product-mobile-hide-table">
        <FSBTable
          data={(data && data?.productList?.productList) || []}
          totalCount={(data && data?.productList?.totalCount) || 0}
          totalPages={(data && data?.productList?.totalPages) || 0}
          columns={productColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters={false}
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          // globalSearchStr={filters.filter[0].value}
          // onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Categories"
        />
      </div>
    </>
  );
};
export default ProductTable;
